import React from 'react';
import styles from './Footer.scss';
import InlineSVG from 'react-svg-inline';
import twitterIcon from '../../imgs/twitter-icon.svg';
import vkIcon from '../../imgs/vk-icon.svg';
import fbIcon from '../../imgs/fb-icon.svg';
import paymentIcon from '../../imgs/accept-payment-icons.svg';


export default function Footer() {
  return (
    <div className={styles.footer}>
      <div className={styles.wrapper}>

        {/* <div className={styles.column}>
          <h5 className={styles.columnHeader}>Каталог товаров</h5>
          <a href="#">Каталоги запчастей</a>
          <a href="#">Запчасти для ТО</a>
          <a href="#">Шины и диски</a>
          <a href="#">Автохимия</a>
          <a href="#">Электрооборудование</a>
        </div>

        <div className={styles.column}>
          <h5 className={styles.columnHeader}>Мы в соц. сетях</h5>
          <div className={styles.shareIconsContainer}>
            <InlineSVG svg={twitterIcon} />
            <InlineSVG svg={vkIcon} />
            <InlineSVG svg={fbIcon} />
          </div>
        </div> */}

        {/* <div className={`${styles.column} ${styles.paymentColumn}`}>
          <h5 className={styles.columnHeader}>Принимаем к оплате</h5>
          <InlineSVG svg={paymentIcon} />
          <p className={styles.text}>
            Так же можно оплатить
            заказ наличными в офисе
          </p>
        </div>

        <div className={styles.column}>
          <h5 className={styles.columnHeader}>Помощь</h5>
          <a href="#">Как сделать заказ</a>
          <a href="#">Как оплатить</a>
          <a href="#">Доставка</a>
          <a href="#">Возврат товара</a>
          <a href="#">Скидки</a>
        </div> */}

        {/* <div className={styles.column}>
          <h5 className={styles.columnHeader}>Партнерам</h5>
          <a href="http://ketex.ru/registration">Поставщикам</a>
          <a href="#">Сколько можно заработать</a>
          <a href="#">Партнерская сеть</a>
        </div>

        <div className={styles.column}>
          <h5 className={styles.columnHeader}>Контакты</h5>
          <p className={styles.text}>8 (495) 649 62 53</p>
          <a href="mailto:order@ketex.ru">order@qq.ru</a>
        </div> */}
      </div>
    </div>
  );
}



/** WEBPACK FOOTER **
 ** ./src/components/Footer/Footer.jsx
 **/